import BlogLeftClassicContainer from "../../../../components/pages/blog/blogDetail/BlogLeftClassic";

const BlogLeftClassic = () => {
  return <BlogLeftClassicContainer />;
};

export default BlogLeftClassic;
